import React, { useState, useMemo, useEffect } from "react";
import { toast } from "react-toastify";
import { connect, useSelector, useDispatch } from "react-redux";
import { Card, Accordion, Form, Row, Col, Dropdown } from "react-bootstrap";
import Select from "react-select";
import "./AssetViewRent.scss";
import TutorialPopup from "../../help/TutorialPopup";
import * as HelpContent from "../../../utils/HelpContent";
import { CHANGE_PAIR, CHANGE_RENT_PAIR, CHANGE_STRATEGY_RENT } from "../../../actions/create-bot-type";
import { getBalance, getPairBalance, getAgenticPairs } from "../../../actions/bot-action";
import { getNewsPairs } from "../../../actions/market-intelligence-action";
import SymbolSearchBox from "../../bots/new-bot/modules/SymbolSearchBox";
import LeftRightForm from "../../bots/new-bot/modules/LeftRightForm";
import { Trans } from "react-i18next";
import BotTitle from "../../bots/new-bot/modules/BotTitle";
import MarketIntelligenceModal from "../../MarketIntelligence/MarketIntelligenceModal";

const AssetViewRent = (props) => {
  const { rentBot,getBalance,t,isEditing,step, getAgenticPairs} = props;
  const MARGIN_SHORT_EXCHANGE_IDS = [17,12, 18,1,100];
  const STRATEGIES = ["Short", "Margin Short"];
  const Exchange = useSelector((state) => state.settings.selectedExchange) || 0;
  const selectedExchange = rentBot.isEditing?rentBot.exchange:Exchange;
  const [baseCoin, setBaseCoin] = useState("usd");
  const templateStrategy = rentBot.rental && rentBot.rental.template && rentBot.rental.template.strategy;
  const templateTitle = rentBot.rental && rentBot.rental.template && rentBot.rental.template.title;
  const isAgenticAi = templateTitle && templateTitle.includes("Agentic AI");
  //const strategy = isEditing?rentBot.strategy:rentBot.rental && rentBot.rental.template && rentBot.rental.template.strategy;
  const [strategy, setStrategy] = useState(templateStrategy === "Short" ? "Short" : "Long");
  const [agenticAiPairs, setAgenticAiPairs] = useState([]);
  const [searchFilter, setSearchFilter] = useState("");
  const [showMarketModal, setShowMarketModal] = useState(false);
  const newsPairs = useSelector((state) => state.marketIntelligence.newsPairs) || [];
  const dispatch = useDispatch();

  const pair = rentBot.pair;
  const selectedPair = pair && {
    value: rentBot.exchangePairId,
    label: `${pair.from}/${pair.to}`,
    from: pair.from,
    to: pair.to,
  };

  const handleSelectPair = (newPair) => {
    getBalance(selectedExchange.id)
    dispatch({
      type: CHANGE_RENT_PAIR,
      payload: newPair,
    });
  };

  const handleAgenticPairSelect = (pair) => {
    handleSelectPair(pair);
  }

  const handleNext = () => {
    if (!rentBot.pair) {
      toast.warn(t("pls-select-stock-symbol"));
      return;
    }
    step('next');
  };

  const strategyChanged = (value) => {
  setStrategy(value);

  dispatch({
    type: CHANGE_STRATEGY_RENT,
    payload: value,
  });
};
  
  useEffect(() => {
    let initial;

    if (selectedExchange?.id === 18 && templateStrategy === "Short") {
      initial = "Margin Short";
    } else if (isEditing && rentBot?.strategy) {
      initial = rentBot.strategy;
    }
    else if (rentBot.strategy){
        initial = rentBot.strategy;
    } 
    else if (rentBot?.rental?.template?.strategy) {
      initial = rentBot.rental.template.strategy;
    } else {
      initial = "Short";
    }

    setStrategy(initial);
    strategyChanged(initial);

  }, [selectedExchange?.id, isEditing]);  

  useEffect(() => {
    if (isAgenticAi && rentBot.rental.id && selectedExchange) {
        getAgenticPairs(selectedExchange.id, rentBot.rental.id).then(res => {
            setAgenticAiPairs(res);
        })
    }
  }, [isAgenticAi, rentBot.rental?.id, selectedExchange?.id])

  useEffect(() => {
    if(newsPairs.length === 0){
        getNewsPairs()
    }
  }, []);
  


    return (
    <>
    <div className="ba-asset-form-content">
      <div className="row gx-0 gy-3">
      <BotTitle rent={true}></BotTitle>
       <LeftRightForm
        left={<><Form.Label>
          {t("exchange")} <TutorialPopup content={t("exchange-help")} />
          </Form.Label></>}
          right={<><div className="mt-1 mb-3">
          <img
            src={selectedExchange.image}
            width={20}
            height={20}
            style={{ marginRight: 10 }}
          />
          <span style={{ fontWeight: "bold", fontSize: 16 }}>
            {selectedExchange.name}
          </span>
        </div></>}
       ></LeftRightForm>
       {isAgenticAi ? 
        <LeftRightForm
            left={<><Form.Label className="bot-asset-tour">
                {t("t-pair")} <TutorialPopup content={t("tradingpair-help")} />
            </Form.Label>
            </>}
            right={<>
                <div style={{ maxWidth: "80%", display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Dropdown onSelect={(eventKey) => {
                    const stock = agenticAiPairs.find(s => String(s.id) === String(eventKey));
                    if(stock) handleAgenticPairSelect(stock);
                }} style={{flex: 1}}>
                    <Dropdown.Toggle 
                        id="dropdown-stock-select"
                        className="agentic-dropdown-toggle"
                        variant="light"
                    >
                        {selectedPair?.value 
                            ? (() => {
                                const selectedStock = agenticAiPairs.find(s => s.id === selectedPair.value);
                                const name = selectedStock?.pair?.from || selectedPair.from;
                                const imageUrl = selectedStock?.pair?.base_image;
                                return (
                                    <div className="d-flex align-items-center">
                                         {imageUrl && <img src={imageUrl} alt={name} style={{width: 20, height: 20, marginRight: 8, borderRadius: '50%', objectFit: 'contain'}} onError={(e) => {e.target.style.display='none'}} />}
                                         <span>{name}</span>
                                    </div>
                                );
                            })()
                            : "Select Stock"
                        }
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ width: '100%', maxHeight: '300px', overflowY: 'auto' }}>
                        <div className="px-2 py-1 sticky-top bg-white border-bottom">
                            <input 
                                type="text"
                                className="form-control form-control-sm agentic-search-input"
                                placeholder="Search..."
                                onChange={(e) => setSearchFilter(e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>
                    {agenticAiPairs
                        .filter(stock => 
                            !searchFilter || 
                            stock.name.toLowerCase().includes(searchFilter.toLowerCase())
                        )
                        .map((stock) => (
                        <Dropdown.Item key={stock.id} eventKey={stock.id}>
                            <div className="d-flex align-items-center">
                                {stock.pair && stock.pair.base_image && <img src={stock.pair.base_image} alt={stock.pair?.from} style={{width: 20, height: 20, marginRight: 8, borderRadius: '50%', objectFit: 'contain'}} onError={(e) => {e.target.style.display='none'}} />}
                                <span className="fw-medium">{stock.pair?.from}</span>
                            </div>
                        </Dropdown.Item>
                    ))}
                    {agenticAiPairs.length === 0 && <div className="p-3 text-muted small">Loading symbols...</div>}
                    </Dropdown.Menu>
                </Dropdown>
                
                {selectedPair?.value && (() => {
                     const selectedStock = agenticAiPairs.find(s => s.id === selectedPair.value);
                     // Check availability logic
                     let isAvailable = false;
                     if (selectedStock) {
                        const pairId = selectedStock.pair_id || selectedStock.id;
                        const found = newsPairs.find(p => String(p.pair_id) === String(pairId));
                        if (found) isAvailable = true;
                        else {
                            // Fallback name check if needed, similar to BotTemplateDetail
                            const name = selectedStock.name;
                            if (newsPairs.find(p => p.name === name)) isAvailable = true;
                        }
                     }

                     return isAvailable ? (
                        <div 
                            onClick={() => setShowMarketModal(true)}
                            className="mi-icon-btn"
                             title="View Market Intelligence"
                        >
                            <img src="/images/MI/ask_anything.svg" alt="Ask Anything" width="24" height="24" />
                        </div>
                     ) : null;
                })()}
                </div>
            </>}
        >
          
        </LeftRightForm>
       :
       <LeftRightForm
       left={<><Form.Label className="bot-asset-tour">
            {t("t-pair")} <TutorialPopup content={t("tradingpair-help")} />
          </Form.Label></>}
       right={<><div style={{ maxWidth: "80%" }}>
            <SymbolSearchBox selectedExchange={selectedExchange} selected={handleSelectPair} selectedPair={selectedPair} rentBot={rentBot}></SymbolSearchBox>
            </div>
            <Form.Label className="mt-2">
              <Trans i18nKey={'miss-pair-note'}><a className="link" href="/setting?loc=8"></a></Trans>
            </Form.Label></>}
       ></LeftRightForm>
       }
       {isAgenticAi &&
       <div className="bot-asset-note">
        <p className="text-muted small mt-1">
              This bot runs our AI model which is trained on a pre-determined set of stocks. If a symbol is not found, you may request for it to be added.
          </p>
        </div>
       }
       {MARGIN_SHORT_EXCHANGE_IDS.includes(selectedExchange.id) 
            && STRATEGIES.includes(strategy)
            ? 
            <LeftRightForm
              //left={<> {t("Strategy")} <TutorialPopup content={t("strategy-help")} /></>}
              left={<>  <Form.Label className="bot-asset-tour">
              {t("Strategy")} <TutorialPopup content={t("strategy-help")} />
            </Form.Label></>}
              right={<> <div className="ba-asset-Strategy-btn">
              {selectedExchange.id !== 18 && <a
              className={strategy === "Short" ? "danger selected" : ""}
              onClick={() => strategyChanged("Short")}
            >
              SHORT
            </a>}

            <a
              className={strategy === "Margin Short" ? "danger selected" : ""}
              onClick={() => strategyChanged("Margin Short")}
            >
              MARGIN SHORT
            </a>
           </div></>}
            ></LeftRightForm>:<></>}
            <div className="col-lg-12">
                <div className="bas-asset-submit bas-asset-btn2">
                  <button onClick={handleNext}>Next</button>
                </div>
            </div>
    </div>
    </div>
    {/* {isAgenticAi && (
        <div className="row mt-3">
            <div className="col-3">
                
            </div>
             <div className="col-9">
                <h5 className="mb-2" style={{fontSize: '14px', color: 'var(--999)'}}>Available Stocks</h5>
                <div className="agentic-symbol-list" style={{border: 'none'}}>
                    {agenticAiPairs.map((stock) => (
                        <div 
                            key={stock.id} 
                            className={`agentic-symbol-item ${selectedPair.value === stock.id ? 'selected' : ''}`} 
                            onClick={() => handleAgenticPairSelect(stock)}
                             >
                            <div className="stock-info">
                                <img src={stock.pair.base_image} alt={stock.pair.from} className="stock-logo" onError={(e) => {e.target.style.display='none'}} />
                                <span className="stock-symbol-text">{stock.name}</span>
                            </div>
                        </div>
                    ))}
                    {agenticAiPairs.length === 0 && <div className="p-3">Loading available stocks...</div>}
                </div>
             </div>
        </div>
    )} */}
            {isAgenticAi && selectedPair?.value && (
                <MarketIntelligenceModal 
                    isOpen={showMarketModal} 
                    close={() => setShowMarketModal(false)} 
                    defaultPairId={agenticAiPairs.find(s => s.id === selectedPair.value)?.pair_id}
                />
            )}
    </>
  );
};

export default connect(null,{getBalance,getPairBalance, getAgenticPairs, getNewsPairs})(AssetViewRent);
